const areaCode = [
  {
    code: 'asi',
    name: 'アジア・中国',
    display: 1,
  },
  {
    code: 'eur',
    name: 'ヨーロッパ',
    display: 2,
  },
  {
    code: 'hwi',
    name: 'ハワイ',
    display: 3,
  },
  {
    code: 'ame',
    name: 'アメリカ・カナダ',
    display: 4,
  },
  {
    code: 'sam',
    name: '中南米・カリブ',
    display: 5,
  },
  {
    code: 'mic',
    name: 'グアム・サイパン',
    display: 6,
  },
  {
    code: 'oce',
    name: 'オセアニア・南太平洋',
    display: 7,
  },
  {
    code: 'afr',
    name: '中近東・アフリカ',
    display: 8,
  },
]

export default areaCode
